import * as React from 'react';
import * as IoC from 'typescript-ioc';
import { useIntl } from 'react-intl';
import { IRoomNarrowed } from '../../../../../../api/rooms.dao';
import { IDateTimeFormatter } from '../../../../../../infrastructure/date-formatter';
import { ConnectionVersion, OPTION_ELIPSIS_MAX_LENGTH } from '../../../../../../constants/common.constants';
import { IAttendeeOrganizationDTO } from '../../../../../../api/attendees.dao';
import { getCompleteRoomName } from '../../../../../../infrastructure/utils/common.utils';
import { NO_ROOM_ASSIGNED_TEXT, ROOMS_UNASSIGNED_TEXT } from './rooms-dropdown.texts';

interface IProps {
    onChange: (roomId: number) => void;
    rooms: IRoomNarrowed[];
    selectedRoomId: number;
    timeZone: string;
    meetingConnectionVersion?: ConnectionVersion;
}

const renderPresenters = (room: IRoomNarrowed) => {
    const intl = useIntl();

    if (room.presenters?.length) {
        return room.presenters.map((presenter: IAttendeeOrganizationDTO) => presenter.name).join(', ') + ' |';
    }

    return intl.formatMessage(ROOMS_UNASSIGNED_TEXT, {
        prefix: '\'',
        suffix: '\' |'
    });
};

// This is temporary decision for rooms dropdown
const optionElipsis = (value: string): string => {
    return value.length > OPTION_ELIPSIS_MAX_LENGTH ? value.slice(0, OPTION_ELIPSIS_MAX_LENGTH) + ' ...' : value;
};

const RoomsDropdown = (props: IProps) => {
    const dateTimeFormatter: IDateTimeFormatter = IoC.Container.get(IDateTimeFormatter);
    const intl = useIntl();
    const renderStartEndTime = (startDateTime: Date, endDateTime: Date) => {
        return dateTimeFormatter.dateToLocalString(startDateTime, props.timeZone) +
            ' | ' + dateTimeFormatter.dateToLocalString(endDateTime, props.timeZone);
    };

    const getFilteredRooms = (): IRoomNarrowed[] => {
        return props.rooms.filter((room: IRoomNarrowed) => {
            const connectionVersion = props.meetingConnectionVersion ?? ConnectionVersion.V1;
            const roomVersion = room.connectionVersion ?? ConnectionVersion.V1;
            return roomVersion === connectionVersion || +room.roomId === props.selectedRoomId;
        });
    };

    return (
        <select
            className='oe-form-field__control'
            value={props.selectedRoomId || ''}
            onChange={event => {
                const value = event.target.value !== '' ? + event.target.value : null;
                props.onChange(value);
            }}>
            <option value=''>
                {intl.formatMessage(NO_ROOM_ASSIGNED_TEXT)}
            </option>
            {getFilteredRooms().map(room => {
                const roomValue = `${getCompleteRoomName(room)} | ${renderPresenters(room)} ${renderStartEndTime(room.startDateTime, room.endDateTime)}`;
                return (
                    <option title={roomValue} key={room.roomId} value={room.roomId}>
                        {optionElipsis(roomValue)}
                    </option>
                );
            })}
        </select>
    );
};

export { RoomsDropdown, renderPresenters, optionElipsis };
